const chatChannels = {
  GROUP_MESSAGES: "groups.messages",
  GROUP_INVITE: "groups.invite",
  GROUP_EXCLUDE: "groups.exclude",
  MESSAGES: "messages",
};

const userTypes = {
  USER: "user",
  UNAUTHORIZED: "unauthorized",
  NO_PROFILE: "no_profile",
};

const THEMES = {
  OLD_THEME: "old-theme",
  DEFAULT_THEME: "default-theme",
};

const popupWindowParams =
  "top=150,left=200,width=1000,height=800,resizable=1,scrollbars=1,menubar=0";

const headerHeight = 52;
const submenuHeight = 32;

const LS_KEYS = {
  WEBPUSH: "wp_token",
  IS_ACTIVE: "feed_is_active",
  INVITE_TIME: "invite_time",
};

/** Параметр, который выставляется на главной странице для некоторых ссылок */
const MAIN_PAGE_QUERY_PARAM = {
  mp_source: "header",
};
const MAIN_PAGE_QUERY_PARAM_STRING = "mp_source=header";

export {
  LS_KEYS,
  chatChannels,
  userTypes,
  popupWindowParams,
  headerHeight,
  submenuHeight,
  MAIN_PAGE_QUERY_PARAM,
  MAIN_PAGE_QUERY_PARAM_STRING,
  THEMES,
};
